import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { categoriesService } from '../api';

const CategoriesContext = createContext(null);
const STORAGE_KEY = 'categoriesCache';

const readCache = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState(readCache);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await categoriesService.getAll();
      const list = Array.isArray(res.data) ? res.data : [];
      setCategories(list);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch {}
    } catch (err) {
      console.error('Greška pri učitavanju kategorija:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const names = categories.map((c) => c.name);

  return (
    <CategoriesContext.Provider value={{ categories, names, isLoading, error, refresh }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategories() {
  const ctx = useContext(CategoriesContext);
  if (!ctx) throw new Error('useCategories must be used within CategoriesProvider');
  return ctx;
}
